import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

const TicketIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64">
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          d="M57,18c-1.504,1.504-2.705,2-5,2c-4.59,0-8-3.41-8-8c0-2.295,0.496-3.496,2-5l-6-6L1,40l6,6c1.504-1.504,2.705-2,5-2c4.59,0,8,3.41,8,8c0,2.295-0.496,3.496-2,5l6,6l39-39L57,18z"
        />
        <line
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          x1="26"
          y1="15"
          x2="30"
          y2="19"
        />
        <line
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          x1="45"
          y1="34"
          x2="49"
          y2="38"
        />
      </g>
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="32"
        y1="21"
        x2="36"
        y2="25"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="39"
        y1="28"
        x2="43"
        y2="32"
      />
    </SvgIcon>
  );
};

export default TicketIcon;
